import { useBridge } from './useBridge';

const useControlBridge = () => {
  const br: any = useBridge();

  const closeWebview = () => {
    br.close();
  };

  return { closeWebview };
};

export default useControlBridge;
